module.exports = __webpack_public_path__ + "img/base_nature_meteo.36d5b15f.svg";